// additive values (see API)
export enum UpdateMethodEnum {
  SMS = 1,
  Email= 2
}
